
import { SERVICES_API } from "../config/api";

class ListsService {

    // Consult Internal Lists ====================================================================================================

    /**
     * Consult Internal Lists
     * @type {object}
     * @property {string} DNI
     * @returns {object} - info
    */
    consultaListasInternas(data) {
        const url = `/consultaListasInternas`;

        return SERVICES_API.post(url, data);
    }


    // Consult International Lists ====================================================================================================

    /**
     * Consult International Lists
     * @type {object}
     * @property {string} nombre
     * @property {string} identifiacion
     * @returns {object} - info
    */
    consultaListasInternacionales(data) {
        const url = `/consultaListasInternacionales`;

        return SERVICES_API.post(url, data);
    }


    // Consult Safe Watch Alert ====================================================================================================

    /**
     * Consult Safe Watch Alert
     * @type {object}
     * @property {number} alerta
     * @returns {object} - info
    */
    consultaAlertaSafeWatch(data) {
        const url = `/consultaAlertaSafeWatch`;

        return SERVICES_API.post(url, data);
    }


    // Consult Alert Number ====================================================================================================

    /**
     * Consult Alert Number
     * @type {object}
     * @property {string} identifiacion
     * @returns {object} - The alert info and number
    */
    consultaNumeroAlerta(data) {
        const url = `/consultaNumeroAlerta`;

        return SERVICES_API.post(url, data);
    }


    // Insert Client On List For Review ====================================================================================================

    /**
     * Insert Client On List For Review
     * @type {object}
     * @property {string} full_name
     * @property {string} email
     * @property {string} document
     * @property {string} font - lista_interna || lista_internacional
     * @property {object} apoderado
     * @property {string} apoderado.full_name
     * @property {string} apoderado.document
     * @property {string} apoderado.font - lista_interna || lista_internacional
     * @property {object} conyuge
     * @property {string} conyuge.full_name
     * @property {string} conyuge.document
     * @property {string} conyuge.font - lista_interna || lista_internacional
     * @property {object} pep
     * @property {string} pep.full_name
     * @property {string} pep.document
     * @property {string} pep.position_pep_id
     * @property {string} pep.font - pep
     * @returns {object} - True/false if the record was inserted
    */
    insertarClienteEnListaParaRevision(data) {
        const url = `/insertarClienteEnListaParaRevision`;

        return SERVICES_API.post(url, data);
    }
    
}

export default new ListsService();